import { AuthType } from "src/components/Email"
import {
  additionalInformationSectionItems,
  companyInformationSectionItems,
  companySpecializationSectionItems,
  partnershipModelSectionItems,
  referralAndGrowthStrategySectionItems,
  RSVP_SURVEY_GROUP_ID,
  RSVP_SURVEY_NO_ID,
} from "../constants"
import { RSVPFormValues, SectionItemsForm } from "../types"
import useSurveyApplication from "./useSurveyApplication"

const entriesSurveyFieldIds = new Map<keyof RSVPFormValues, number>([
  ["companyName", 122988],
  ["website", 122989],
  ["companyOverview", 122990],
  ["primaryContactName", 122992],
  ["primaryContactTitle", 122993],
  ["primaryContactEmail", 122995],
  ["primaryContactPhone", 122997],
  ["address", 122999],
  ["hospitalityOperationsConsulting", 123000],
  ["financialBusinessPlanning", 123001],
  ["marketingBrandStrategy", 123002],
  ["franchiseExpansionConsulting", 123003],
  ["technologyDigitalStrategy", 123004],
  ["projectManagementImplementation", 123005],
  ["customITSolutionsEngineering", 123006],
  ["otherSpecialization", 123007],
  ["partnershipCommunity", 123008],
  ["experienceWorking", 123009],
  ["integratePVPlatform", 123010],
  ["clientOpportunities", 123011],
  ["coMarketingOpportunities", 123012],
  ["referencesPastClients", 123013],
  ["additionalInformation", 123014],
])

const SURVEY_CREDENTIALS: AuthType = {
  api_username: "rsvp_form",
  api_password: "A9f8Jk2L3mN4oP5Qr6St7Uv8Wx9Yz0aBcDeFgHiJkLmN",
  api_key: "bd84c56a-042a-4c2f-ade2-11000b119b68",
  company_no: 1257,
  username: "rsvp_user",
  password: "FWJIjg249jiJGe84w230jaipogiHEWGw4r3",
}

const useRSVPForm = () => {
  const { onSubmit: onSubmitSurvey } = useSurveyApplication()

  const initialValues: RSVPFormValues = {
    companyName: "",
    website: "",
    companyOverview: "",
    primaryContactName: "",
    primaryContactTitle: "",
    primaryContactEmail: "",
    primaryContactPhone: "",
    address: "",
    partnershipCommunity: "",
    experienceWorking: "",
    integratePVPlatform: "",
    clientOpportunities: "",
    coMarketingOpportunities: "",
    referencesPastClients: "",
    additionalInformation: "",
    hospitalityOperationsConsulting: "",
    financialBusinessPlanning: "",
    marketingBrandStrategy: "",
    franchiseExpansionConsulting: "",
    technologyDigitalStrategy: "",
    projectManagementImplementation: "",
    customITSolutionsEngineering: "",
    otherSpecialization: "",
  }

  const formItems: SectionItemsForm[] = (() => {
    return [
      { ...companyInformationSectionItems },
      { ...companySpecializationSectionItems },
      { ...partnershipModelSectionItems },
      { ...referralAndGrowthStrategySectionItems },
      { ...additionalInformationSectionItems },
    ]
  })()

  const onSubmit = async (values: RSVPFormValues) => {
    const entries = Object.entries(values)
    const payload = entries.reduce((acc, [key, value]) => {
      const surveyFieldNo = entriesSurveyFieldIds.get(key as keyof RSVPFormValues)
      if (surveyFieldNo && value) {
        acc[surveyFieldNo] = value
      }
      return acc
    }, {} as Record<number, string>)

    await onSubmitSurvey({
      surveyNoId: RSVP_SURVEY_NO_ID,
      surveyGroupId: RSVP_SURVEY_GROUP_ID,
      payload,
      surveyAuth: SURVEY_CREDENTIALS,
    })
  }

  return {
    initialValues,
    formItems,
    onSubmit,
  }
}

export default useRSVPForm
